module.exports = __webpack_public_path__ + "static/media/katrineholm_2.db386e8a.jpg";